<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M7.348 8.662v18.67h13.099V8.662H7.348zm-.336-2c-.927 0-1.679.745-1.679 1.666v19.338c0 .92.752 1.667 1.68 1.667h13.77c.927 0 1.679-.747 1.679-1.667V8.328c0-.92-.752-1.667-1.68-1.667H7.012z"/><path d="M11.726 2.666a1.004 1.004 0 00-1.013.995 1.004 1.004 0 001.002 1.005l12.93.074v12.923c0 .553.451 1 1.008 1 .556 0 1.007-.447 1.007-1V3.858a1.004 1.004 0 00-.996-1.112l-13.938-.08z"/></g></svg>
</template>

<script>
export default {
  name: 'symbolsCopyOutline'
}
</script>
